<template>
  <div v-if="hasVisibleContent" class="read-status-container">
    <!------- 읽음 표시 -------->
    <div class="read-users">
      <!-- readGbn 02: 숫자만, 툴팁 없음 -->
      <template v-if="normalizedReadGbn === '02'">
        <span class="read-users-trigger">{{ t('task.home.readStatus.read') }}&nbsp;{{ readUserCnt }}</span>
      </template>
      <!-- readGbn 03: 읽은 사람 목록 툴팁 -->
      <template v-else-if="normalizedReadGbn === '03'">
        <UiTooltip v-if="readUserList.length > 0" position="bottom" fixed autoFlip>
          <template #trigger>
            <span class="read-users-trigger">{{ t('task.home.readStatus.read') }}&nbsp;{{ readUserCnt }}</span>
          </template>
          <div class="read-users-tooltip">
            <p v-for="(name, index) in readUserList" :key="`${name}-${index}`">{{ name }}</p>
          </div>
        </UiTooltip>
        <span v-else class="read-users-trigger">{{ t('task.home.readStatus.read') }}&nbsp;{{ readUserCnt }}</span>
      </template>
    </div>
    <template v-if="unreadCnt > 0">
      <span class="icon-new" @click="handleNewClick">NEW</span>
    </template>
    <!------- 읽음 표시 -------->
  </div>
</template>

<script setup>
const { t } = useI18n();

import { computed } from 'vue';

const { readGbn } = useCollaborationStore();

/** '3' / '03' 등 응답 형식 통일 */
const normalizedReadGbn = computed(() => String(readGbn.value ?? '').padStart(2, '0'));

const props = defineProps({
  // 읽은 사람 수
  readUserCnt: {
    type: [String, Number],
    default: 0,
  },
  // 읽은 사람 목록
  readUserStr: {
    type: String,
    default: '',
  },
  // 안읽은 활동 수
  unreadCnt: {
    type: [Number],
    default: 0,
  },
});

/** readGbn 01: 읽음 N 미표시 — NEW만 남을 수 있음 */
const hasVisibleContent = computed(() => {
  if (normalizedReadGbn.value === '01') return props.unreadCnt > 0;
  return true;
});

const emit = defineEmits(['new-click']);

/** readUserStr(쉼표 구분) → 사용자별 한 줄 목록 */
const readUserList = computed(() => {
  const str = props.readUserStr || '';
  if (!str.trim()) return [];
  return str
    .split(',')
    .map(name => name.trim())
    .filter(Boolean);
});

const handleNewClick = () => {
  emit('new-click');
};
</script>

<style scoped lang="scss">
.read-status-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.read-users {
  flex: none;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #6d7882;
  text-align: right;
}

.read-users-trigger {
  cursor: default;
}

/* 툴팁 본문: 왼쪽 정렬 + 사용자별 줄바꿈 */
:deep(.read-users-tooltip) {
  text-align: left;

  p {
    margin: 0;
    line-height: 1.5;

    & + p {
      margin-top: 4px;
    }
  }
}

:deep(.ui-tooltip-content) {
  text-align: left;

  strong {
    text-align: left;
  }
}
</style>
